import React from 'react';

import { useLanguage } from '../LanguageContext';

const buttonStyle = (selected, size = 'lg') => {
  return selected ? 'btn-rsvp-choice-selected' : 'btn-rsvp-choice';
};

export default function PhysicalInvitationStep({
  formData,
  setFormData,
  onNext,
  onBack,
}) {
  const { t } = useLanguage();
  const selectPhysicalInvitation = (value) => {
    setFormData((s) => ({ ...s, physicalInvitation: value }));
  };

  return (
    <div className="space-y-6 max-w-md mx-auto text-center font-normal">
      <h2 className="text-4xl text-content-h1">
        {t('rsvp_form.physical_invitation_title')}
      </h2>
      <div className="grid gap-4">
        <button
          type="button"
          onClick={() => {
            selectPhysicalInvitation(true);
            setTimeout(() => onNext(), 500);
          }}
          className={buttonStyle(formData.physicalInvitation === true)}
        >
          {t('rsvp_form.physical_invitation_yes')}
        </button>
        <button
          type="button"
          onClick={() => {
            selectPhysicalInvitation(false);
            setTimeout(() => onNext(), 500);
          }}
          className={buttonStyle(formData.physicalInvitation === false)}
        >
          {t('rsvp_form.physical_invitation_no')}
        </button>
      </div>
    </div>
  );
}
